import { useState, useEffect, useRef, useCallback } from 'react'
import { getWebSocketUrl } from 'config/websocket'

/**
 * Хук для получения непрочитанных сообщений через WebSocket.
 * Сервер пушит обновления мгновенно при новых сообщениях.
 * При разрыве соединения — авто-реконнект через 5 сек.
 */
export default function useChatUnread(isAuthenticated) {
  const [totalUnread, setTotalUnread] = useState(0)
  const wsRef = useRef(null)
  const reconnectTimer = useRef(null)
  const mountedRef = useRef(true)

  const connect = useCallback(() => {
    if (!isAuthenticated || !mountedRef.current) return

    const token = localStorage.getItem('token')
    if (!token) return

    const url = getWebSocketUrl('ws/unread/') + `?token=${token}`
    const ws = new WebSocket(url)
    wsRef.current = ws

    ws.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data)
        if (data.type === 'unread_count' && mountedRef.current) {
          setTotalUnread(data.total ?? 0)
        }
      } catch { /* ignore parse errors */ }
    }

    ws.onclose = () => {
      if (mountedRef.current && isAuthenticated) {
        // Авто-реконнект через 5 секунд
        reconnectTimer.current = setTimeout(connect, 5000)
      }
    }

    ws.onerror = () => ws.close()
  }, [isAuthenticated])

  useEffect(() => {
    mountedRef.current = true

    if (isAuthenticated) {
      connect()
    } else {
      setTotalUnread(0)
    }

    return () => {
      mountedRef.current = false
      clearTimeout(reconnectTimer.current)
      if (wsRef.current) {
        wsRef.current.onclose = null // не триггерить реконнект при размонтировании
        wsRef.current.close()
      }
    }
  }, [isAuthenticated, connect])

  return totalUnread
}
